{
  "customer-request-online-booking-dialog": {
    "buttons": {
      "submit": "SUBMIT"
    },
    "text": {
      "title": "Online booking request",
      "email": "Your email",
      "hint": "The salon does not yet offer online appointment booking. Leave your email and we will notify you when online appointment booking is enabled for the salon in the future",
      "request-sent-success": "Your request was sent successfully!"
    }
  }
}
